import { reactive, computed } from "@vue/composition-api";
import useMouseSvg from "@/composables/useMouseSvg";
import annotations from "@/store/modules/annotations";
import ui from "@/store/modules/ui";

export default function useLabel() {
  const state = reactive({
    selectedLabelType: computed(() => ui.selectedLabelType)
  });

  const labels = computed(() => annotations.getLabels);

  const place = e => {
    // if not left mouse button, return
    if (e.button !== 0) return;
    // if selected type is empty, return
    if (state.selectedLabelType === "") return;
    const { pos: mousePosSvg } = useMouseSvg(e);
    const newPt = mousePosSvg(e);

    const newLabel = {
      name: state.selectedLabelType,
      pos: {
        cx: newPt.x,
        cy: newPt.y
      }
    };

    annotations.addLabel({ newLabel });
  };

  const move = (e, index) => {
    // return if not pressed by the left(main) mouse button
    if (e.button !== 0) return;
    // get svg element (the canvas)
    const elem = e.currentTarget.closest("svg");
    const { pos: mousePosSvg } = useMouseSvg(e);

    let moving = true;
    let newPt;

    const updateFn = () => {
      if (moving) requestAnimationFrame(updateFn);

      annotations.set({ path: `labels[${index}].pos.cx`, value: newPt.x });
      annotations.set({ path: `labels[${index}].pos.cy`, value: newPt.y });
    };

    const moveFn = e => {
      newPt = mousePosSvg(e);
    };

    const stopFn = () => {
      moving = false;
      elem.removeEventListener("mousemove", moveFn);
      elem.removeEventListener("mouseup", stopFn);
    };

    requestAnimationFrame(updateFn);
    moveFn(e);

    elem.addEventListener("mousemove", moveFn);
    elem.addEventListener("mouseup", stopFn);
  };

  const remove = (e, index) => {
    // if not left mouse button, return
    if (e.button !== 0) return;

    annotations.removeLabel({ i: index });
  };

  return {
    labels,
    place,
    move,
    remove
  };
}
